import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { MyOmeKitSheet, MyOmeKitSheetProps } from './MyOmeKitSheet';
import { printDocumentInIframe } from './printDocumentInIframe';

const buildKitSheetDocument = (sheetProps: MyOmeKitSheetProps) =>
  [
    '<!doctype html>',
    '<html><head><meta charset="utf-8">',
    '<title>MyOme kit sheet</title>',
    '<style>@page { size: letter; margin: 0; } body { margin: 0; }</style>',
    '</head><body>',
    '<div style="width: 8.5in; box-sizing: border-box;">',
    // @types/react-dom resolves a newer @types/react than the app does.
    renderToStaticMarkup(
      (<MyOmeKitSheet {...sheetProps} />) as Parameters<
        typeof renderToStaticMarkup
      >[0],
    ),
    '</div></body></html>',
  ].join('');

export type PrintMyOmeKitSheetParams = Omit<MyOmeKitSheetProps, 'printedAt'> & {
  /** Called once the print dialog closes. */
  onDone?: () => void;
};

/**
 * Opens the browser print dialog for the MyOme kit sheet, stamped with the
 * current time. Returns a function that cancels and cleans up.
 */
export const printMyOmeKitSheet = ({
  onDone,
  ...sheetProps
}: PrintMyOmeKitSheetParams) =>
  printDocumentInIframe({
    html: buildKitSheetDocument({ ...sheetProps, printedAt: new Date() }),
    onDone,
  });
